import styled from 'styled-components';
import { breakpointLG } from '../styles/breakpoints';
import { fontSemibold16 } from '../styles/fonts';
import { StyledLink } from '../styles/ui';
export const CustomLink = styled(StyledLink) `
  display: flex;

  &:last-child {
    margin: 0;
  }
`;
export const Wrapper = styled.div `
  display: flex;
  align-items: center;
  padding: 16px;

  .title {
    ${fontSemibold16}
  }

  @media (min-width: ${breakpointLG}) {
    padding: 16px 24px;
  }
`;
//# sourceMappingURL=styles.js.map